import React from 'react'
import { ourteam, img1, img2, user1, user2, user3, aboutusbg, mayor1, mayor2 } from '../../../public/LoginImages/importimages'




const AboutUs = () => {

  return (
    <>

      <div style={{ width: '100vw', textAlign: 'center', color: 'white', backgroundImage: `url('${aboutusbg}')`, backgroundSize: 'contain', padding: '45px', overflow: 'auto' }}>
        <h2>About Us</h2>
        <div style={{ fontSize: '12px', lineHeight: '20px', fontSize: '15px', textAlign: 'center' }}> <p>Bareilly district is located in 26.0 longitude and 78.0 longitude. This district was previously part of Panchala. The Gomti River in the east, the Yamuna in the west,
          the Chambal in the south and the Himalayan ranges in the north are its frontier boundaries.</p>
          <p>Panchal was considered the high center of Vedic culture. The virtues here were famous all over the country. Bareilly is also excellent from the perspective of geology. Avesh of Panchal is found near Rampur village. 500 thousand coins before the Gupta era have been obtained from Ahichchatra. This district has also been
            ahead in the statues of Harakota. Panchala was one of the 6 Mahajanapadas in the 16th century.</p>
          <p>By the middle of the 12th century the Kshatriyas settled themselves there. Bareilly district would have been established in the 16th century. It is said that a Kshatriya named Jagatsingh established a village named Jagat Pur. He had two sons, Bansu Dev, Barel Dev. Both the brothers settled the Bareilly district in 1537 and
            then it was named Bas Bareilly. The name of a locality of Bareilly is still Jagatpur. After the death of Bamboo Dev of Bareilly, Bareilly was incorporated into the
            Mughal Empire.</p>
          <p>The rapid development of this district began in 1657 with full vigor. At that time, the faujdar of Bareilly was Mukrand Rai. He founded many locales like Biharipur,
            Malkapur, Kazitola etc. He got a huge fort built at the Jama Masjid and Fort Police Station.</p>
          <p>The freedom struggle in Bareilly started on 14 May 1857. Local residents of Bareilly staged several demonstrations in protest and burnt papers etc. in front of Kotwali.</p>
          <p>The Indian National Congress was founded during the Khilafat movement in Bareilly. Gandhiji first arrived in Bareilly at the same time. The Civina Disobedience
            Movement started in this district on 26 January 1930. Jawaharlal Nehru, MN Rai, Purushottam Rai etc. participated in a session of the Congress. Many processions
            related to Quit India movement were also taken out and about 200 people were arrested.</p>
        </div>
      </div>

      <div className="container" style={{ height: 'auto' }}>
        <div className="row justify-content-around my-5">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <img style={{ paddingRight: '53px' }} className="img-fluid" src={img1} alt="Vision" />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <h3 className="text-center font-weight-bold">Our Vision</h3>
            <li >
              High standards of services for the public who have an actual or potential interest in the working of Bareilly Municipal Corporation.
            </li>
            <li >
              Sustainable excellence and transparency in the formulation of policies dovetailing it with courtesy, promptness, and reliability in its day-to-day functioning.
            </li>
            <li>
              To make City a dream city to live, to visit, and relish its memories.
            </li>
          </div>
        </div>

        <div className="row justify-content-around" style={{ display: "flex", flexWrap: "wrap-reverse" }}>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <h3 className="text-center font-weight-bold">Our Mission</h3>
            <li>
              To ensure running and maintenance of civic services and facilities such as water supply, sewage system
            </li>
            <li>
              To issue license/permits for shops, business establishments
            </li>
            <li>
              To regulate opening/closing shops and markets
            </li>
            <li>
              To run public health services
            </li>
            <li>
              To maintain record of land and properties owned by it
            </li>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <img style={{ paddingRight: '53px' }} className="img-fluid" src={img2} alt="Mission" />
          </div>
        </div>
      </div>

      <div className='cards mt-4' style={{ backgroundImage: `url('${ourteam}')`, backgroundSize: 'contain' }}>
        <div style={{ textAlign: 'center' }}>
          <h3>Our Team</h3>
          {/* <p>Lorem ipsum dolor sit amet, consectetuer adipiscing el</p> */}
        </div>
        <div className='card-container' style={{ display: 'flex', flexWrap: 'wrap', width: '100%', height: '24rem', overflow: 'auto', justifyContent: 'center' }}>

          <div className="card hovereffect" style={{ width: '16rem', margin: '2rem', height: '20rem', }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img className='img-fluid' style={{ padding: '10px 0px 0px 20px' }} width='150px' src={mayor1} />
            </div>
            <div className="card-body" style={{ display: "grid" }}>
              <p style={{ textAlign: "center", color: 'orange', fontSize: '20px' }} className="card-title">Shri Dr. Umesh Gautam</p> <p style={{ textAlign: 'center' }}>Hon. Mayor Bareilly
                Nagar Nigam</p>
              {/* <div >
                Lorem ipsum dolor sit amet,
                consectetuer adipiscing elit
              </div> */}
            </div>
          </div>

          {/* <div className="card hovereffect" style={{ width: '16rem', margin: '2rem', height: '20rem', }}>
            <img className='img-fluid' style={{ padding: '10px 0px 0px 20px' }} width='150px' src={user1} />
            <div className="card-body" style={{ display: "grid" }}>
              <p style={{ textAlign: "center", color: 'orange', fontSize: '20px' }} className="card-title">Shri Ajit Kumar Singh</p> <p style={{ textAlign: 'center' }}>Additional Municipal Commissioner</p>
              <div>
                <p>Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit</p>
              </div>
            </div>
          </div> */}

          <div className="card hovereffect" style={{ width: '16rem', margin: '2rem', height: '20rem', }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img className='img-fluid' style={{ padding: '10px 0px 0px 20px' }} width='150px' src={mayor2} />
            </div>
            <div className="card-body" style={{ display: "grid" }}>
              <p style={{ textAlign: "center", color: 'orange', fontSize: '20px' }} className="card-title">Smt. Nidhi Gupta Vats (I.A.S.)</p> <p style={{ textAlign: 'center' }}>Municipal Commissioner Nagar Nigam Bareilly</p>
              {/* <div>
                <p> Lorem ipsum dolor sit amet,
                  consectetuer adipiscing elit</p>
              </div> */}
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default AboutUs